import React from 'react'
import Loader from "../loader/Loader";
import {OrderCard} from "./OrderCard";

interface OrderCardGroupInterface {
    isLoading: boolean,
    isError: boolean|Object,
    data: any[]|Object,
    actionUrl?: string,
    actionButtons: any[],
    max?: number,
    user: Object,
}

const OrderCardGroup = ({
    isLoading = false,
    isError = false,
    data = [],
    actionUrl = '#',
    actionButtons = [],
    max = 3,
    user = false,
}: OrderCardGroupInterface) => {
    return (
        <>
        <div className={"mb-3"}>
            {!isLoading && !isError && (
                data.slice(0, max).map((item, i) => {
                    return (
                        <OrderCard key={i} item={item} index={i} actionButtons={actionButtons} user={user}/>
                    )
                })
            )}

            {!isLoading && !isError && actionUrl !== '#' && (
                <div className={"d-flex justify-content-center"}>
                    <a href={actionUrl}
                       className="btn btn-primary">
                        Voir plus
                    </a>
                </div>
            )}

            {isLoading && <Loader/>}
        </div>
        </>
    )
}

export default OrderCardGroup
